import React from 'react';
import Icon from "Common/Icon/Icon";
import Wrapper from './Clock.style';
import { Subject, interval } from "rxjs";
import { takeUntil, timeInterval } from "rxjs/operators";

export default class extends React.Component {

    onTick$    = new interval(1000);
    onDestroy$ = new Subject();

    constructor(props) {
        super(props);

        this.state = {
            date: new Date(),
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.date.getMinutes() !== nextState.date.getMinutes();
    }

    componentDidMount() {
        this.onTick$.pipe(takeUntil(this.onDestroy$), timeInterval()).subscribe(() => {
            this.setState(() => ({ date: new Date() }));
        });
    }

    componentWillUnmount() {
        this.onDestroy$.next();
    }

    strPad( str ) {
        return `${str}`.padStart(2, '0');
    }

    renderDate() {
        return (
            <React.Fragment>
                { this.strPad(this.state.date.getDate()) }.
                { this.strPad(this.state.date.getMonth() + 1) }.
                { this.strPad(this.state.date.getFullYear()) }
                <span className="pipe">|</span>
                { this.strPad(this.state.date.getHours()) }:
                { this.strPad(this.state.date.getMinutes()) }
                &nbsp;Uhr
            </React.Fragment>
        );
    }

    render () {
        return (
            <Wrapper>
                <Icon type="clock-circle" />
                <span>
                    { this.renderDate() }
                </span>
            </Wrapper>
        );
    }

}
